import React from 'react';

import Loader from '../../../../common/components/notifications/Loader';
import Editor from './PlayerPreferenceEditor';

class EditorController extends React.Component {
    constructor (props) {
        super(props)
        this.state = this.props.store();
    }

    componentWillMount () {
        var self = this;

        this.removeListener = this.props.store(function onChange (data) {
            self.setState(data);
        });

        const id = this.props.preferenceID();
        if (id) {
            this.props.actions.playerPreference.getByID({
                playerPrefID: id
            });
        }

        this.props.actions.getMiscAssets();
        this.props.actions.getP2Pstatus();
    }

    componentWillUnmount () {
        this.removeListener();
    }

    render () {
        if (this.state.preference.isResolving) {
            return <Loader message="Fetching"/>;
        }

        const {
            emitSnack,
            actions,
            preferenceID,
            clientID,
            onWorkspaceAction
        } = this.props;

        const { data, loadFailed } = this.state.preference;
        const prefID = this.state.preference.preferenceID || preferenceID();

        return (<Editor
            preference={data}
            preferenceID={prefID}
            clientID={clientID}
            loadFailed={loadFailed}
            assets={this.state.assets}
            peerStatus={this.state.peerStatus}
            actions={actions}
            emitSnack={emitSnack}
            onWorkspaceAction={onWorkspaceAction}
        />);
    }
}

export default EditorController;
